export const GET_SURVEYS = 'surveys/GET_SURVEYS';
export const GET_SURVEYS_BY_STUDENT_ID = 'surveys/GET_SURVEYS_BY_STUDENT_ID';
